import Home from '../Home/Home';
import ReactDOM from 'react-dom';
import Form  from './Form';

  const UserRegistration = () => {
    return (
        <Home>
        <div className="App">
        <div>
        <Form></Form>
        <br></br>
        <br></br>
       
        </div>
       
      </div>
      </Home>
    );
  };

  export default UserRegistration;

